import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import '@progress/kendo-theme-default/dist/all.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSelector } from 'react-redux';
import { Pagination } from 'antd';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import InvoiceTable from './Common/InvoiceTable';
import SelectList from './Common/SelectList';
import AlertMessage from './Common/AlertMessage';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const AllInvoices = ({ isShow, setIsShow }) => {
    const invoiceTable = [
        {
            Sno: 1,
            memberMobile: 'Hemant(8457478436)',
            pkg: 'Fitness',
            amount: 1299,
            method: 'Cash',
            invoice: 'w|625',
            receipt: 'w|625',
            receiver: 'Sharan',
            pDate: '2076-11-12',
            nPDate: '2076-11-12'
        }
    ];

    const [data, setData] = useState(invoiceTable);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const { alert } = useSelector(state => state.alert);
    const dataRef = React.createRef();

    const isDelete = (item) => {
        const newData = data.filter(e => { return e.Sno !== item.Sno });
        setData(newData)
        console.log(newData);
    };

    const handleDelete = (item) => {
        confirmAlert({
            message: "Are you sure you want to Delete?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => isDelete(item)
                },
                {
                    label: 'Cancel',
                    onClick: () => null
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        })
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <div className='page_first_div '>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>All Invoices</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/receipt/" className='link block text-white text-sm'>
                        <i className="fa-solid fa-square-plus mr-1"></i>
                        Add
                    </Link>
                </div>
                <section className='page_section min-h-[23rem]'>

                    {/* showing success message when form updated */}
                    {alert && <AlertMessage />}

                    {/* Selectors,Inputs,SearchBar */}
                    <form className='flex flex-col justify-center px-4 xsm:px-8 lg:flex-row 2xl:justify-start items-center flex-wrap gap-4 py-4 '>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector  w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Member--</option>
                                <option value="Maria" className=''>Maria</option>
                                <option value="Hemant">Hemant</option>
                                <option value="Rajiv">Rajiv</option>
                                <option value="Sharan">Sharan</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Membership--</option>
                                <option value="Cash" >Cash</option>
                                <option value="Cheque">Cheque</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Payment Method--</option>
                                <option value="Cash" >Cash</option>
                                <option value="Cheque">Cheque</option>
                                <option value="Debit-Card">Debit-Card</option>
                                <option value="Credit-Card">Credit-Card</option>
                                <option value="Online">Online</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Tax--</option>
                                <option value="GST" >GST</option>
                                <option value="Vat">Vat</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector  w-full lg:w-80 bg-gray-100">
                                <option value=''>--Received By--</option>
                                <option value="Maria" className=''>Maria</option>
                                <option value="Hemant">Hemant</option>
                                <option value="Rajiv">Rajiv</option>
                                <option value="Sharan">Sharan</option>
                            </select>
                        </div>
                        <div className='font-lato text-sm xsm:text-base w-full lg:w-80'>
                            <DatePicker placeholder='Receipt/Next Payment Date' format="dd MMMM yyyy" className='date_picker' />
                        </div>
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </form>

                    {/* show option and convert buttons */}
                    <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
                        <SelectList
                            setPostPerPage={setPostPerPage}
                            data={data}
                        />
                        <ConvertButtons
                            ref={dataRef}
                            data={data}
                        />
                    </div>

                    {/* Invoice Table */}
                    <InvoiceTable
                        data={currentPost}
                        sortData={data}
                        setData={setData}
                        onDelete={handleDelete}
                        searchTerm={searchTerm}
                        ref={dataRef}
                    />

                    {/* Showing table length with Pagination */}
                    <div className='px-4 xsm:px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>
                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AllInvoices;